module.exports = __webpack_public_path__ + "static/media/mimi4.6b657423.gif";